export enum TipoOrigemVariavelEnum {
  Sistema = 1,
  TagXml = 2,
  Parametro = 3,
}
